import React from 'react'
import { BrowserRouter as Router, Route, Routes,  } from "react-router-dom";
import Lobby from './components/Lobby';
import Room from './components/Room';


export default function App() {
  return (
    <div>

<Router>
  <Routes>
    <Route path='/' element={<Lobby/>}/>
    <Route path='/room/:roomId' element={<Room/>}/>
    
  </Routes>
</Router>


    </div>
  )
}
